import React, { useEffect, useState } from "react";
import "./../../Assets/css/BookingPage.scss";
import VNLeftContent from "../../Components/Booking/components/VaccineNotices/components/VNLeftContent";
import VNRightContent from "../../Components/Booking/components/VaccineNotices/components/VNRightContent";
import BFLeftContent from "../../Components/Booking/components/BookingForm/BFLeftContent";
import BFRightContent from "../../Components/Booking/components/BookingForm/BFRightContent";
import AboutYou from "../../Components/Booking/components/BookingForm/AboutYou/AboutYou";
import AboutTrip from "../../Components/Booking/components/BookingForm/AboutTrip/AboutTrip";
import YourBooking from "../../Components/Booking/components/BookingForm/YourBooking/YourBooking";
import PaymentDetails from "../../Components/Booking/components/BookingForm/PaymentDetails/PaymentDetails";
import ChatSuggestions from "../../Components/Booking/components/BookingForm/ChatSuggestions/ChatSuggestions";
import TravelVaccineContent from "../../Components/Booking/components/BookingForm/TravelVaccineContent/TravelVaccineContent";
import FormSuccess from "../../Components/Booking/components/BookingForm/FormSuccess/FormSuccess";
import useBookingApp from "../../hooks/useBookingApp";
import PCLeftContent from "../../Components/Booking/components/PreConsultation/PCLeftContent";
import PCRightContent from "../../Components/Booking/components/PreConsultation/PCRightContent";
import TripOverview from "../../Components/Booking/components/PreConsultation/TripOverview/TripOverview";
import TripPurpose from "../../Components/Booking/components/PreConsultation/TripPurpose/TripPurpose";
import EnvironmentType from "../../Components/Booking/components/PreConsultation/EnvironmentType/EnvironmentType";
import AddCountryModal from "../../Components/Booking/components/PreConsultation/AddCountryModal/AddCountryModal";
import AccommodationType from "../../Components/Booking/components/PreConsultation/AccommodationType/AccommodationType";
import RequiredMedicalQuestions from "../../Components/Booking/components/PreConsultation/RequiredMedicalQuestions/RequiredMedicalQuestions";
import VaccineSelection from "../../Components/Booking/components/PreConsultation/VaccineSelection/VaccineSelection";
import VaccineHistory from "../../Components/Booking/components/PreConsultation/VaccineHistory/VaccineHistory";
import { act } from "react";

export default function Booking() {
  const { bookingSectionState } = useBookingApp();
  const { companyDetails, bookingModel, isEnablePrePayment } = bookingSectionState;
  const pharmacyName = companyDetails?.pharmacies[0].pharmacyName;

  const mainColor = "#252392";
  const secondaryColor = "#DBEAFE";

  const [preConsultation, setPreConsultation] = useState(false);

  const savedStep = parseInt(localStorage.getItem("last-active-step"), 10);
  const initialStep = !isNaN(savedStep) ? savedStep : 0;

  const [bookingFormSteps, setBookingFormSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(initialStep);
  const [activeStepTitle, setActiveStepTitle] = useState("");
  const [userFirstName, setUserFirstName] = useState(bookingModel?.FirstName);

  useEffect(() => {
    if (!companyDetails) return;

    const isFromRefresh = localStorage.getItem("fromRefresh") === "true";

    if (!isFromRefresh) {
      const steps = [
        { title: "Travel Vaccine Notices" },
        { title: "Tell us about you", visited: false },
        { title: "Tell us about your trip", visited: false },
        { title: "Your Booking", visited: false },
      ];

      if (isEnablePrePayment) {
        steps.push({ title: "Payment Details", visited: false });
      }

      steps.push({ title: "Success" });

      setBookingFormSteps(steps);
    }
  }, [companyDetails]);

  useEffect(() => {
    setActiveStepTitle(bookingFormSteps[initialStep]?.title);
  }, [bookingFormSteps, initialStep]);

  useEffect(() => {
    if (bookingModel?.FirstName || pharmacyName) {
      const message = `Hey ${bookingModel.FirstName}! Welcome to ${pharmacyName}. We’re really looking forward to getting you ready for your trip! Let us know where you’re travelling so we have a rough idea of what vaccines you might need.`;
      setCountrySelectionMessages([message]);
      setUserFirstName(bookingModel.FirstName); // optional
    }
  }, [bookingModel?.FirstName, pharmacyName]);


  const [activeStepPC, setActiveStepPC] = useState(0);

  const [enableDateTimeSelection, setEnableDateTimeSelection] = useState(false);
  const [countrySelectionMessages, setCountrySelectionMessages] = useState([
    `Hey ${userFirstName}! Welcome to ${pharmacyName}. We’re really looking forward to getting you ready for your trip! Let us know where you’re travelling so we have a rough idea of what vaccines you might need.`,
  ]);
  const [openCountryModal, setOpenCountryModal] = useState(false);
  const [tripCountries, setTripCountries] = useState([]);
  const [selectedCountriesModal, setSelectedCountriesModal] = useState([]);

  const [preConsultationSteps, setPreConsultationSteps] = useState([
    {
      title: "Tell us about your trip",
      type: "about-trip",
    },
  ]);

  const [activeStepTitlePC, setActiveStepTitlePC] = useState(
    preConsultationSteps[0].title
  );
  const [tripSelections, setTripSelections] = useState(null);

  const handleNextStep = () => {
    setEnableDateTimeSelection(false);

    setActiveStep((prevStep) => {
      const newStep = prevStep + 1;
      localStorage.setItem("last-active-step", newStep);
      setActiveStepTitle(bookingFormSteps[newStep]?.title);

      return newStep;
    });

    setBookingFormSteps((prev) => {
      const updatedSteps = [...prev];
      updatedSteps[activeStep] = {
        ...updatedSteps[activeStep],
        visited: true,
      };
      localStorage.setItem("stepper-navigation", JSON.stringify(updatedSteps));
      return updatedSteps;
    });
  };

  const handlePrevStep = () => {
    setEnableDateTimeSelection(false);
    setActiveStep((prevStep) => {
      const newStep = Math.max(prevStep - 1, 0);
      localStorage.setItem("last-active-step", newStep);
      setActiveStepTitle(bookingFormSteps[newStep]?.title);
      return newStep;
    });
  };

  const handleNextStepPC = () => {
    setActiveStepPC((prevStep) => {
      const nextStep = prevStep + 1;

      const nextTitle = preConsultationSteps[nextStep]?.title;
      setActiveStepTitlePC(nextTitle || "Tell us about your trip");
      return nextStep;
    });
  };

  const handlePrevStepPC = () => {
    if (activeStepPC > 0) {
      setActiveStepPC((prevStep) => prevStep - 1);
      setActiveStepTitlePC(preConsultationSteps[activeStepPC - 1]?.title);
    }
  };

  const renderStepContentLeft = (step) => {
    switch (Number(step)) {
      case 0:
        return (
          <VNLeftContent
            mainColor={
              companyDetails?.primaryColor || "#252392"
            }
            handleNextStep={handleNextStep}
          />
        );
      case 1:
        return (
          <TravelVaccineContent
            mainColor={companyDetails?.primaryColor}
            secondaryColor={companyDetails?.secondaryColor}
            description={companyDetails?.description}
          />
        );
      case 2:
      case 3:
      case 4:
      case 5:
        return (
          <ChatSuggestions
            mainColor={companyDetails?.primaryColor}
            countrySelectionMessages={countrySelectionMessages}
            secondaryColor={companyDetails?.secondaryColor}
            activeStep={activeStep}
            enableDateTimeSelection={enableDateTimeSelection}
            setPreConsultation={setPreConsultation}
          />
        );

      default:
        return;
    }
  };

  const renderStepContentRight = (step) => {
    const stepTitle = bookingFormSteps[step]?.title;

    switch (stepTitle) {
      case "Travel Vaccine Notices":
        return <VNRightContent mainColor={companyDetails?.primaryColor} />;

      case "Tell us about you":
        return (
          <AboutYou mainColor={companyDetails?.primaryColor} handleNextStep={handleNextStep} />
        );

      case "Tell us about your trip":
        return (
          <AboutTrip
            mainColor={companyDetails?.primaryColor}
            handleNextStep={handleNextStep}
            setCountrySelectionMessages={setCountrySelectionMessages}
          />
        );

      case "Your Booking":
        return (
          <YourBooking
            mainColor={companyDetails?.primaryColor}
            handleNextStep={handleNextStep}
            secondaryColor={companyDetails?.secondaryColor}
            enableDateTimeSelection={enableDateTimeSelection}
            setEnableDateTimeSelection={setEnableDateTimeSelection}
          />
        );

      case "Payment Details":
        return (
          <PaymentDetails
            mainColor={companyDetails?.primaryColor}
            handleNextStep={handleNextStep}
          />
        );

      case "Success":
        return (
          <FormSuccess
            mainColor={companyDetails?.primaryColor}
            setPreConsultation={setPreConsultation}
          />
        );

      default:
        return null;
    }
  };

  const renderStepContentRightPC = () => {
    const currentStep = preConsultationSteps[activeStepPC];

    if (!currentStep) return null;

    switch (currentStep.type) {
      case "about-trip":
        return (
          <TripOverview
            mainColor={companyDetails?.primaryColor || "#252392"}
            setOpenCountryModal={setOpenCountryModal}
            tripCountries={tripCountries}
            setTripCountries={setTripCountries}
            setSelectedCountriesModal={setSelectedCountriesModal}
            preConsultationSteps={preConsultationSteps}
            setPreConsultationSteps={setPreConsultationSteps}
            setActiveStepPC={setActiveStepPC}
            handleNextStepPC={handleNextStepPC}
          />
        );

      case "vaccine-selection":
        return (
          <VaccineSelection
            mainColor={companyDetails?.primaryColor || "#252392"}
            tripCountries={tripCountries}
            tripSelections={tripSelections}
            setTripSelections={setTripSelections}
            setActiveStepPC={setActiveStepPC}
            preConsultationSteps={preConsultationSteps}
            handleNextStepPC={handleNextStepPC}
          />
        );

      case "trip-purpose":
        return (
          <TripPurpose
            mainColor={companyDetails?.primaryColor || "#252392"}
            tripCountries={tripCountries}
            tripSelections={tripSelections}
            setTripSelections={setTripSelections}
            setActiveStepPC={setActiveStepPC}
            preConsultationSteps={preConsultationSteps}
            handleNextStepPC={handleNextStepPC}
            countryName={currentStep.countryName}
            countryCode={currentStep.countryCode}
          />
        );

      case "environment-type":
        return (
          <EnvironmentType
            mainColor={companyDetails?.primaryColor || "#252392"}
            tripCountries={tripCountries}
            tripSelections={tripSelections}
            setTripSelections={setTripSelections}
            setActiveStepPC={setActiveStepPC}
            handleNextStepPC={handleNextStepPC}
            countryName={currentStep.countryName}
            countryCode={currentStep.countryCode}
          />
        );

      case "accommodation-type":
        return (
          <AccommodationType
            mainColor={companyDetails?.primaryColor || "#252392"}
            tripCountries={tripCountries}
            tripSelections={tripSelections}
            setTripSelections={setTripSelections}
            setActiveStepPC={setActiveStepPC}
            handleNextStepPC={handleNextStepPC}
            countryName={currentStep.countryName}
            countryCode={currentStep.countryCode}
          />
        );

      case "vaccine-history":
        return (
          <VaccineHistory
            mainColor={companyDetails?.primaryColor || "#252392"}
            tripSelections={tripSelections}
            setTripSelections={setTripSelections}
            handleNextStepPC={handleNextStepPC}
          />
        );

      case "required-medical-questions":
        return (
          <RequiredMedicalQuestions
            mainColor={companyDetails?.primaryColor || "#252392"}
            handleNextStepPC={handleNextStepPC}
            tripSelections={tripSelections}
            setTripSelections={setTripSelections}
          />
        );

      default:
        return null;
    }
  };

  return (
    <section
      className={`booking-content-wrapper ${preConsultation ? "pc" : ""}`}
    >
      <section className="booking-content-container">
        <section className="left">
          {/*First check whether our flow is Pre Consultation or Booking */}

          {preConsultation ? (
            <PCLeftContent
              preConsultation={preConsultation}
              activeStepPC={activeStepPC}
              mainColor={
                companyDetails?.primaryColor || "#252392"
              }
              tripCountries={tripCountries}
              logo={companyDetails?.logo}
            />
          ) : (
            <>
              <BFLeftContent
                activeStep={activeStep}
                renderStepContentLeft={renderStepContentLeft}
                logo={companyDetails?.logo}
              />
            </>
          )}
        </section>
        <section className="right">
          {/*First check whether our flow is Pre Consultation or Booking */}
          {preConsultation ? (
            <PCRightContent
              mainColor={
                companyDetails?.primaryColor || "#252392"
              }
              activeStepPC={activeStepPC}
              setActiveStepPC={setActiveStepPC}
              activeStepTitlePC={activeStepTitlePC}
              setActiveStepTitlePC={setActiveStepTitlePC}
              preConsultationSteps={preConsultationSteps}
              renderStepContentRightPC={renderStepContentRightPC}
              handleNextStepPC={handleNextStepPC}
              handlePrevStepPC={handlePrevStepPC}
            />
          ) : (
            <BFRightContent
              mainColor={
                companyDetails?.primaryColor || "#252392"
              }
              handleNextStep={handleNextStep}
              handlePrevStep={handlePrevStep}
              activeStep={activeStep}
              activeStepTitle={activeStepTitle}
              bookingFormSteps={bookingFormSteps}
              setBookingFormSteps={setBookingFormSteps}
              setActiveStep={setActiveStep}
              setActiveStepTitle={setActiveStepTitle}
              renderStepContentRight={renderStepContentRight}
            />
          )}
        </section>
      </section>

      {openCountryModal && (
        <AddCountryModal
          mainColor={companyDetails?.primaryColor || "#252392"}
          openCountryModal={openCountryModal}
          setOpenCountryModal={setOpenCountryModal}
          setTripCountries={setTripCountries}
          selectedCountriesModal={selectedCountriesModal}
          setSelectedCountriesModal={setSelectedCountriesModal}
        />
      )}
    </section>
  );
}
